export enum UserContext {
  Individual = 'individual',
  Company = 'company',
  Admin = 'admin',
}
